<template>
	<div class="box" v-loading="loading" :element-loading-text="$t('bc.bc_50')"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<infoview :tabs="3"></infoview>

		<div style="width: 100%;">
			<p class="pwdtext">{{$t('bc.bc_42')}}</p>
			<p class="pwdtextsmall">{{$t('ModifyPwd.ModifyPwd_lbl0')}}</p>
			<div style="width: 100%; margin-top: 5%;  ">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left">
					<el-form-item :label="$t('ReserveCar.ReserveCar_13')">
						{{ruleForm.userid}}
					</el-form-item>
					<el-form-item :label="$t('ModifyPwd.ModifyPwd_lbl1')" prop="code">
						<div>
							<el-input style="width: 30%;" v-model="ruleForm.code"
								onkeyup="this.value=this.value.replace(/[^\d]/g,'') " maxlength="5" placeholder="CODE">
							</el-input>
							<el-button v-if="sendconfirm" @click="sendCode" class="codemsg" style="">{{codemsg}}
							</el-button>
							<el-button v-else class="codemsg" style="">{{codemsg}}</el-button>
						</div>
					</el-form-item>

					<el-form-item :label="$t('ModifyPwd.ModifyPwd_lbl3')" prop="pwd">
						<el-input style="width: 50%;" v-model="ruleForm.pwd" type="password" placeholder="PASSWORD">
						</el-input>
					</el-form-item>
					<el-form-item :label="$t('ModifyPwd.ModifyPwd_lbl4')" prop="twopwd">
						<el-input style="width: 50%;" v-model="ruleForm.twopwd" type="password" placeholder="PASSWORD">
						</el-input>
					</el-form-item>

					<div style="width: 60%; text-align: center; margin-bottom: 20px;" >
						<el-button class="btn" @click="submitmodify">
							{{$t('ModifyPwd.ModifyPwd_lbl5')}}
						</el-button>
					</div>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import infoview from '../components/home/info/infoview.vue'
	export default {
		name: 'ModifyPwd',
		components: {
			infoview
		},
		inject: ['reload'],
		data() {

			// 验证码证规则
			const validateVerifycode = (rule, value, callback) => {
				if (value == '') {
					callback(new Error(this.$t('Register.Register_lbl14'))); //请输入验证码
				} else if (value.length != 5) {
					callback(new Error(this.$t('bc.bc_40')));
				} else {
					callback();
				}
			}


			const validatePwd = (rule, value, callback) => { //请输入密码
				var res = (/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,18}$/)
				if (value === '') {
					callback(new Error(this.$t('Register.Register_lbl15')));
				} else if (!res.test(value)) {

					callback(new Error(this.$t('bc.bc_9')));
				} else {
					callback();
				}
			};
			const validateTwoPwd = (rule, value, callback) => { //请输入密码
				var res = (/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,18}$/)
				if (value === '') {
					callback(new Error(this.$t('Register.Register_lbl15')));
				} else if (!res.test(value)) {

					callback(new Error(this.$t('bc.bc_9')));
				} else if (value != this.ruleForm.pwd) {
					callback(new Error(this.$t('Register.Register_lbl26')));
				} else {
					callback();
				}
			};
			return {
				getcode: '',
				loading: false,
				lang: 0,
				ruleForm: {
					userid: sessionStorage.getItem("log_email"),
					code: '',
					pwd: '',
					twopwd: ''
				},
				codemsg: '',
				sendconfirm: true,
				timer: null,
				count: "",

				rules: {

					twopwd: [{ //提示清输入第二次输入密码
						trigger: ['blur', 'change'],
						validator: validateTwoPwd
					}],
					pwd: [{ //提示请输入密码
						trigger: ['blur', 'change'],
						validator: validatePwd
					}],
					code: [{ //提示清输入验证码
						trigger: ['blur', 'change'],
						validator: validateVerifycode
					}],
				},
			}
		},
		created() {
			clearInterval(this.timer);
			this.timer = null;
			this.sendconfirm = true;
			this.codemsg = this.$t('ResetPassword.ResetPassword_lbl4');
			// this.ruleForm.userid=''
			// this.ruleForm.code=''
			// this.ruleForm.password=''

            if (this.$i18n.locale == 'ja') {
				this.lang = 0
			}
			else if (this.$i18n.locale == 'zh') {
				this.lang = 1
			}
			else if (this.$i18n.locale == 'en') {
				this.lang = 2
			}
		},
		methods: {

			submitmodify() {
				let myDate = new Date();
				let yy = myDate.getFullYear()
				let mm = myDate.getMonth() + 1 < 10 ? '0' + myDate.getMonth() + 1 : myDate.getMonth() + 1;
				let dd = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
				let hh = myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours();
				let ff = myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes();
				let stime = yy + '年' + mm + '月' + dd + '日' + ' ' + hh + ':' + ff
				console.log(stime)
                console.log('this.lang:' + this.lang)
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						if (this.getcode == this.ruleForm.code) {
							this.loading = true
							this.$api.post(this.$config.Upd_Pwd, {
									// 'YHSEQNUM': localStorage.getItem('YHSEQNUM')
									'sEMAIL': this.ruleForm.userid,
									'sPassword': this.ruleForm.pwd,
									'sTIME': stime,
									'sLNGCT': this.lang
								},
								// 请求成功
								success => {
									this.loading = false
									console.log(success)
									if (success.KKSTR == 'Y') {
										this.$message.success(this.$t('Register.Register_lbl24'));
										sessionStorage.clear();
										this.$router.push('/')
										this.reload();
										this.userid = ''
										this.setCookie("", "", -1)
									} else if (success.KKSTR == 'N') {
										this.$message({
											message: this.$t('Register.Register_lbl25'), //该账号已经注册
											type: 'error'
										});
									} else if (success.KKSTR == 'E') {
										this.$message({
											message: this.$t('bc.bc_24'), //该账号已经注册
											type: 'error'
										});
									}
								},
								// 请求失败
								error => {
									console.log(error)
								}
							)
						} else {
							this.loading = false
							this.$message({
								message: this.$t('bc.bc_53'), //验证码错误
								type: 'error'
							});

						}
					} else {
						this.loading = false
						this.$message({
							message: this.$t('bc.bc_37'), //请求失败
							type: 'error'
						});
					}
				});
			},

			setCookie(c_name, c_pwd, exdays) {
				var exdate = new Date(); //获取时间
				exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
				//字符串拼接cookie
				window.document.cookie =
					"userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
				window.document.cookie =
					"userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
			},
			sendCode() {
				this.loading = true
				let myDate = new Date();
				let yy = myDate.getFullYear()
				let mm = myDate.getMonth() + 1 < 10 ? '0' + myDate.getMonth() + 1 : myDate.getMonth() + 1;
				let dd = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
				let hh = myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours();
				let ff = myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes();
				let stime = yy + '年' + mm + '月' + dd + '日' + ' ' + hh + ':' + ff
				let curCount = 0;
				let TIME_COUNT = 60;
				this.$api.post(this.$config.Get_Upd_Code, {
						'sTIME': stime,
						'sEMAIL': this.ruleForm.userid,
						'sLNGCT': this.lang
					},
					// 请求成功
					success => {
						this.loading = false
						console.log(success)
						if (success.KKSTR == 'N') {
							this.$message({
								message: this.$t('Register.Register_lbl29'), //该账号已经注册
								type: 'error'
							});
						} else if (success.KKSTR == 'E') {

							this.$message({
								message: this.$t('bc.bc_24'), //该账号已经注册
								type: 'error'
							});
						} else {

							if (!this.timer) {
								this.count = TIME_COUNT;
								this.timer = setInterval(() => {
									if (this.count > 0 && this.count <= TIME_COUNT) {
										curCount = this.count--;
										this.codemsg = curCount + "s";
										this.sendconfirm = false;
									} else {
										this.sendconfirm = true;
										this.codemsg = this.$t('ModifyPwd.ModifyPwd_lbl2');
										clearInterval(this.timer);
										this.timer = null;
									}
								}, 1000);
							}
							this.$message({
								message: this.$t('bc.bc_46'), //发送成功
								type: 'success'
							});
							this.getcode = success.KKSTR
						}
					},
					// 请求失败
					error => {
						this.loading = false
						console.log(error)
					}
				)
			}
		}




	}
</script>

<style scoped>
	@media only screen and (min-width:800px) {
		.box {
			width: 80%;
			display: flex;
			flex-direction: row;
			margin: auto;
			padding-top: 60px;
		}

		.codemsg {

			margin-left: 5%;
			border-color: #666666;
			background-color: #666666;
			color: #FFFFFF;
			/* width: 25%; */
		}

		/deep/ .el-form-item__label {
			font-size: 14px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			/* font-weight: bold; */
			color: #000000;
			width: 22%;
		}

		.pwdtext {

			font-size: 50px;
			font-family: Roboto-Bold, Roboto;
			font-weight: bold;
			color: #000000;
		}
		
		/deep/ .el-button{
			padding: 12px 5px  !important;
			
		}

	}

	@media only screen and (max-width:800px) {
		.box {
			width: 90%;
			margin: auto;
			padding-top: 10px;
			display: block;
		}
		
		/deep/ .el-button{
			padding: 12px 0px  !important;
			
		}
		
		
		.codemsg {
			font-size: 10px;
			margin-left: 3%;
			border-color: #666666;
			background-color: #666666;
			color: #FFFFFF;
		}

		/deep/ .el-form-item__label {
			font-size: 12px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			/* font-weight: bold; */
			color: #000000;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 40px;
			line-height: 1;
			width: 24%;
		}

		.pwdtext {

			font-size: 30px;
			font-family: Roboto-Bold, Roboto;
			font-weight: bold;
			color: #000000;
			margin-top: 20px;
		}

	}


	.pwdtextsmall {
		font-size: 12px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #000000;
	}

	.btn {
		width: 120px;
		height: 35px;
		background: #000000;
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #FFFFFF;
		border-color: #000000;
	}


	.row {
		display: flex;
		flex-direction: row;
	}

	.f-b {
		justify-content: space-between;
	}
</style>
